export const PROFILE_ID = 'profileId';
export const PROFILE_CONFIGURATION = 'profileConfiguration';

export const FORM_MAX_LENGTH = {
    SMALL_TEXT: 128,
    DEFAULT: 255,
    PHONE_NUMBER: 14,
    SSN: 9,
    STATE: 2,
    ZIP: 10,
    // TODO maxlength default for message - 1024
    MESSAGE: 850,
    TEXT: 1024,
};

export const DECISION_COMMENT_MAX_LENGTH = 4000;

export const FUZZINESS_LEVEL_DEFAULT = 100;
